<template>
  <div class="navbar">

    <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />

    <div class="right-menu">

      <template v-if="device!=='mobile'">

        <el-tooltip placement="top">
          <!-- <div slot="content">
            <div style="width: 200px">
              <div>{{versionInfo.versionNumber}}</div>
              <div style="display: flex; justify-content: space-between; padding: 5px 0">
                <span>新功能</span>
                <span>{{versionInfo.promulgateDate}}</span>
              </div>
              <div>{{versionInfo.versionRemark}}</div>
              <div style="text-align: center; margin-top: 10px; cursor: pointer; color: #169BD5" @click="moreLog">更多记录</div>
            </div>
          </div> -->
          <!-- <div class="versionNum">版本号：{{versionInfo.versionNumber}}</div> -->
        </el-tooltip>

      </template>

      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="hover">
        <div class="avatar-wrapper">
          <i class="el-icon-user-solid user-avatar" style="font-size:30px;text-align:center;"></i>
          <i class="el-icon-caret-bottom" ></i>
        
        </div>
        <el-dropdown-menu slot="dropdown">
          <span style='font-size: 12px;padding:20px;color:rgb(171, 171, 171);'>账号：{{ loginPhone }}</span>
          <el-dropdown-item divided @click.native="logout">
           
            <span style="display:block;">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>


      <el-dialog title="版本历史记录" width="50%" :close-on-click-modal="false" :destroy-on-close="true" :visible.sync="dialogTableVisible">
        <div class="historyLog" v-for="(item, index) in historyList" :key="index">
          <div class="versionDate">
            <span>{{item.versionNumber}}</span>
            <span>{{item.promulgateDate}}</span>
          </div>
          <div>{{item.versionRemark}}</div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Binfomation from '@/components/Binfomation'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import ErrorLog from '@/components/ErrorLog'
import Screenfull from '@/components/Screenfull'
import SizeSelect from '@/components/SizeSelect'
import Search from '@/components/HeaderSearch'
// import { getNewVersion, getVersionList } from '@/api/version'

export default {
  components: {
    Binfomation,
    Breadcrumb,
    Hamburger,
    ErrorLog,
    Screenfull,
    SizeSelect,
    Search
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'device',
      'ssourl',
      'loginPhone'
    ])
  },
  data() {
    return {
      dialogTableVisible: false,
      versionInfo: {
        versionNumber: '',
        versionRemark: '',
        promulgateDate: ''
      },
      historyList: [],
    }
  },
  created(){
  },
  mounted() {
    // this.handleNewVersion()
    // this.handleVersionList()
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    logout() {
      var ssa = window.location.host
      this.$store.dispatch('user/logout')
        var ht = document.location.protocol 
      if (ssa == 'localhost:9527') {
        window.location.href =ht+'//'+this.ssourl +'/api/v2/logout?redirect='+ht+'//' + ssa + '/login'
      } else {
        window.location.href =ht+'//'+this.ssourl +'/api/v2/logout?redirect='+ht+'//' + ssa + '/login'
      }
      sessionStorage.removeItem('saveTitle')
    },
    moreLog() {
      this.dialogTableVisible = true
    },
    handleNewVersion() {
      getNewVersion().then(res => {
        if (res.code == 1) {
          this.versionInfo = {
            versionNumber: res.data.versionNumber,
            versionRemark: res.data.versionRemark,
            promulgateDate: res.data.promulgateDate
          }
        }
      })
    },
    handleVersionList() {
      getVersionList().then(res => {
        if (res.code == 1) {
          this.historyList = res.data
        }
      })
    }
  }
}
</script>

<style scoped>


/deep/ .el-dialog__body {
  padding: 0px 20px 30px;
}
</style>
<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    .versionNum {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      vertical-align: text-bottom;
      font-size: 14px;
      color: #606266;
    }

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
  .historyLog {
    line-height: 15px;
    border-bottom: 1px solid #eee;
    padding: 10px 0;
    .versionDate {
      display: flex;
      justify-content: space-between;
      padding: 5px 0;
    }
  }
}
</style>
